import React from "react";

import {withApollo} from "react-apollo";

import SweetAlert from "react-bootstrap-sweetalert";

import withStyles from "material-ui/styles/withStyles";

import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";
import Button from "components/CustomButtons/Button.jsx";

import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";

import Loading from "../../etc/Loading";
import {client, subClient} from "client";
import { queueCallSub, removePinQueue } from "../graph";


class CallFormQueue extends React.Component{
    constructor(props) {
        super(props);

        this.inlineInterval = null;

        this.state = {
            timer: 0,
            position: 0,
            doneLoading: false
        };

        this.queueCallSubClient = null;
    }

    componentDidMount() {
      this.queueCallSubClient = client.subscribe({
        query: queueCallSub, 
        variables: {pin: this.props.pin, pid: this.props.pid}
      }).subscribe(
        response => {
          if (!this.inlineInterval)
            this.startCounter();

          const data = JSON.parse(response.data.queueCallSub.jsonObject);
          const pos = parseInt(data.position) + 1;

          if (data.success) {
            clearInterval(this.inlineInterval);

            if (this.queueCallSubClient) {
                this.queueCallSubClient.unsubscribe();
                this.queueCallSubClient = null;
            }

            this.props.onCallFormQueueSuccess();
          }

          this.setState({
            position: pos,
            doneLoading: true
          });
        },
        error => {
        }
      );
    }

    componentWillUnmount() { 
      if (this.queueCallSubClient) {
          this.queueCallSubClient.unsubscribe();
          this.queueCallSubClient = null;
      }
      clearInterval(this.inlineInterval);
    }

    startCounter() {
        this.inlineInterval = setInterval(() => {
            let t = this.state.timer;

            t++;

            this.setState({
              timer: t
            });
        }, 1000);
    }

    onQueueDoneClick() {
      client.mutate({
        mutation: removePinQueue,
        variables: ({
          pin: this.props.pin, 
          pid: this.props.pid
        }),
          fetchPolicy: "no-cache"
      }).then((data) => {}); 

      if (this.queueCallSubClient) {
          this.queueCallSubClient.unsubscribe();
          this.queueCallSubClient = null;
      }
      clearInterval(this.inlineInterval);

      this.props.onCallFormQueueClose()
    }

    render() {
        const { timer, position, waitText, doneLoading } = this.state;
        let body = null;
        let showConfirm = true;
        let title = "Your call is in queue!";

        if (!doneLoading) {
          showConfirm = false;
          title = "Loading call, please wait...";
          body = (<Loading />);
        }
        else {
          body = (
            <GridContainer>
              <ItemGrid xs={12}>
                <h1>Queue #<b>{position}</b></h1>
              </ItemGrid>
              <ItemGrid xs={12}>
                All lines are currently busy, please wait for your turn! :)
              </ItemGrid>
              <ItemGrid xs={12}>
                <small>Please don't close this window or you will be removed from the queue</small>
              </ItemGrid>
              <hr/>
              <ItemGrid xs={12}>
                <small style={{float: 'right'}}>{timer}</small>
              </ItemGrid>
            </GridContainer>
          );
        }

        return (
            <SweetAlert
              title={title}
              onConfirm={this.onQueueDoneClick.bind(this)}
              showConfirm={showConfirm}
              confirmBtnText="Cancel Call"
              allowOutsideClick={false}
              allowEscapeKey={false}
              closeOnConfirm={false}
              closeOnCancel={false}
            >
            {body}
          </SweetAlert>
        );
    }
}

export default withStyles(sweetAlertStyle)(withApollo(CallFormQueue));


// WEBPACK FOOTER //
// ./src/views/callform/components/CallFormQueue.js